import { createReducer } from '@reduxjs/toolkit'

import { FilterOptionsBody } from 'types/GlobalAttributeOptions'
import { arrayToObject } from 'utils/functions'

import * as actions from '../../actions/FilterOptions/actions'
import * as authenticationActions from '../../actions/Authentication/actions'

export interface FilterOptionReducerType {
  data: FilterOptionsBody
  fetched: boolean
}

// Initial state
const INITIAL_STATE: FilterOptionReducerType = {
  data: {},
  fetched: false
}

// Reducer
const kpiTemplateReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getAllSuccess, (state, action) => {
      const { payload } = action

      return {
        ...state,
        data: arrayToObject(payload),
        fetched: true
      }
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})

export default kpiTemplateReducer
